import { render } from "./pret-avance.vue?vue&type=template&id=615eef71"
import script from "./pret-avance.vue?vue&type=script&lang=js"
export * from "./pret-avance.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__